module.exports = __webpack_public_path__ + "static/media/company-icon.63dccfe1.svg";